import { createRoot } from 'react-dom/client';
import '../styles/globals.css';
import SobreNosotros from './pages/sobre-nosotros.jsx';

createRoot(document.getElementById('root')).render(<SobreNosotros />);
